import MyTable from "components/UIElements/MyTable";

export default function DeviceStatus({ endPoint }) {

    const columns = [
        {
            title: 'ΙΜΕΙ Συσκευής',
            key: 'imei',
            dataIndex: 'imei',
        },
        {
            title: 'IMSI',
            dataIndex: 'imsi',
            key: 'imsi',
        },
        {
            title: 'Αρ. Συμβολαίου',
            dataIndex: 'policyNumber',
            key: 'policyNumber',
        },
        {
            title: 'Κατάσταση Συσκευής',
            key: 'deviceStatus',
            dataIndex: 'deviceStatus',
        },
        {
            title: 'Ημ/νία Ενημέρωσης Κατάστασης Συσκευής',
            key: 'deviceStatusDate',
            dataIndex: 'deviceStatusDate',
        },
        {
            title: 'Ημ/νία Τελευταίας Σύνδεσης',
            key: 'lastSeen',
            dataIndex: 'lastSeen'
        },
        {
            title: 'Ημ/νία Έναρξης Καταγραφής Χιλ.',
            key: 'initialKilometersDate',
            dataIndex: 'initialKilometersDate'
        },
        {
            title: 'Ημ/νία Τελευταίας Καταγραφής Χιλ.',
            key: 'latestKilometersDate',
            dataIndex: 'latestKilometersDate',
        },
        {
            title: 'Συνολικά Χιλιομ.',
            key: 'kilometers',
            dataIndex: 'kilometers'
        },
        {
            title: 'Ημ/νία Alarm Plugin',
            key: 'latestAlarmPluginDate. ',
            dataIndex: 'latestAlarmPluginDate'
        },
        {
            title: 'Ημ/νία Alarm Plugout',
            key: 'latestAlarmPlugoutDate',
            dataIndex: 'latestAlarmPlugoutDate'
        },
    ];

    return <MyTable columns={columns} endPoint={endPoint} />

}